import { utils } from './utils.js';
import { myInput } from './input.js';
import { lang } from './lang.js';
import { historie } from './history.js';
import { myToolbar } from './tools/toolbar.js';
import { beads } from './beads.js';
import { settings } from './settings.js';
import { menu } from './menu.js';
import { save } from './projects/save.js';
import { modes } from './modes.js';
import { beadLibrary } from './tools/beadLibrary.js';
import defaultPalette from '../lib/defaultPalette.js';

export const palette = {};

palette.initializeSettings = () => {

    palette.activeStyleId = null;
    palette.beadSoup = []; // array of style IDs in current bead soup
    if (b3.store.state.swatches) {
        b3.store.state.swatches.forEach(element => element.rt.destroy());
    }
    b3.store.mySet('swatches', []);
    palette.swatchIndex = 0;
};

palette.newProject = config => {
    palette.initializeSettings();
    if (config.loading) return;

    config.collection === 'Default palette' ?
        palette.addDefaultPalette():
        palette.addFromMyCollection(config.collection);
};

palette.initializeSwatches = ({renameColors}) => { // used for changing libraries

    b3.store.state.swatches.forEach(element => {
        element.finishName = utils.convertFinishName(element.finishName);
        if (renameColors) {
            element.description = utils.returnApproxColor(element.fillColor);
        }
        element.render();
    });
    menu.resetPaletteTable();
};

palette.clickOnSwatch = swatch => {
    if (!myInput.pointerEnabled) return;
    if (b3.store.state.beadSoupActive) {
        settings.toggleBeadSoup();
    }
    palette.select(swatch);
    if (myInput.SHIFT.isDown) {
        modes.start('editSwatch');
    } else if (myInput.ALT.isDown) {
        palette.selectBeads(swatch);
    } else {
        palette.clickSwatch(swatch);
    }
};

palette.addPaletteToStore = file => {
    b3.store.state.palettes.push(file);
};

class Swatch {
    constructor (x, y, fillColor, description, finishName, inner, secondColor, letterCode, id) {
        this.rt = game.add.renderTexture(x, y, 36, Math.floor(settings.beadDisplayHeight * 0.6)).setOrigin(0.5).myIgnore();
        this.fillColor = fillColor;
        this.secondColor = secondColor;
        this.selected = false;
        this.description = description;
        this.finishName = finishName;
        this.letterCode = letterCode;
        this.inner = inner || 'opaque'; // to change later
        this.id = (typeof id === 'number') ? id : palette.swatchIndex;
        palette.swatchIndex++;

        this.render();
    }

    render () { // render swatch
        if (!this.rt) return; // added

        this.rt.clear();
        const myObject = {
            x: this.rt.width / 2,
            y: this.rt.height / 2,
            fillAlpha: 1,
            fillColor: this.fillColor,
            secondColor: this.secondColor,
            finishName: this.finishName,
            inner: this.inner,
            letterCode: this.letterCode,
            shape: settings.library.shape,
            angle: 0,
            active: true,
            scale: 0.6,
            selected: false
        }
        beads.render(myObject, this.rt);
    }

    hasBeadsOnCanvas () {
        return beads.arr.some(bead => !bead.ignore && bead.style === this.id);
    }

    getBeadCount () {
        return beads.arr.filter(bead => !bead.ignore && bead.style === this.id).length;
    }
}


palette.addSwatch = ({fillColor, description, finishName, inner, secondColor, letterCode=null, addHistory=true, position=null, id=null}) => {
    const newList = b3.store.state.swatches;

    // let i = newList.length;
    // let mySwatch = new Swatch(30, 115 + (i * ((settings.beadDisplayHeight * 0.6) + 5)), fillColor, description, finishName, inner, secondColor, letterCode, id);
    let mySwatch = new Swatch(-100, -100, fillColor, description, finishName, inner, secondColor, letterCode, id);

    if (position === null) {
        newList.push(mySwatch);
    } else {
        newList.splice(position, 0, mySwatch);
    }

    palette.select(mySwatch);

    if (addHistory) {
        const myAction = {
            deleteSwatch: false,
            position: newList.indexOf(mySwatch),
            swatch: {
                fillColor: mySwatch.fillColor,
                secondColor: mySwatch.secondColor,
                letterCode: mySwatch.letterCode,
                finishName: mySwatch.finishName,
                inner: mySwatch.inner,
                description: mySwatch.description,
                id: mySwatch.id
            }
        };
        historie.addAction({myAction});
    }

    b3.store.mySet('swatches', newList);
    return mySwatch;
};

palette.finishList = [
    {lower: 'matte', display: 'Matte', x: 100},
    {lower: 'semigloss', display: 'Semi-Gloss', x: 140},
    {lower: 'gloss', display: 'Gloss', x: 180},
    {lower: 'cylinder_matte', display: 'Matte', x: 100},
    {lower: 'cylinder_semigloss', display: 'Semi-Gloss', x: 140},
    {lower: 'cylinder_gloss', display: 'Gloss', x: 180},
    {lower: 'plastic', display: 'Plastic', x: 180},
];

palette.innerList = [
    {lower: 'opaque', display: 'Opaque', x: 100},
    {lower: 'transparent', display: 'Transparent', x: 140},
    {lower: 'insidecolor', display: 'Inner Color', x: 180},
];

palette.addOrUpdateSwatch = ({
    letterCode, fillColor, description, finishName, inner, secondColor, isNew
}) => {

    if (isNew) {
        palette.addSwatch({fillColor, description, finishName, inner, secondColor, letterCode});
        palette.closeSwatchDialog();
        return;
    }

    const mySwatch = b3.store.state.swatches.find(s => s.selected);
    if (!mySwatch) return;

    mySwatch.letterCode = letterCode;
    mySwatch.fillColor = fillColor;
    mySwatch.description = description;
    mySwatch.finishName = finishName;
    mySwatch.inner = inner;
    mySwatch.secondColor = secondColor;

    mySwatch.render();

    const swatchCopy = b3.store.state.swatches.slice();
    b3.store.mySet('swatches', swatchCopy);

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.style === mySwatch.id) beads.render(bead);
    });

    historie.addAction();
    menu.resetPaletteTable();
    palette.closeSwatchDialog();
};

palette.deleteSwatchAndClose = () => {

    const mySwatch = b3.store.state.swatches.find(s => s.selected);
    if (!mySwatch) return;

    palette.deleteSwatch(mySwatch);
    palette.closeSwatchDialog();
};

palette.deleteSwatch = (swatch, addHistory=true) => {
    let myIndex = b3.store.state.swatches.indexOf(swatch);

    // make a copy (for history section below)

    let swatchCopy = {
        fillColor: swatch.fillColor,
        secondColor: swatch.secondColor,
        letterCode: swatch.letterCode,
        finishName: swatch.finishName,
        inner: swatch.inner,
        description: swatch.description,
        id: swatch.id
    };

    // delete the swatch

    swatch.rt.destroy();
    b3.store.state.swatches.splice(myIndex, 1);

    if (addHistory) {
        // now add history action
        const myAction = {
            deleteSwatch: true,
            position: myIndex,
            swatch: swatchCopy
        };

        historie.addAction({myAction});
    }

    if (palette.beadSoup.some(element => element == swatch.id)) {
        palette.beadSoup = [];
        myToolbar.disableTool('Soup');
        if (b3.store.state.beadSoupActive) {
            palette.select(b3.store.state.swatches[0]);
        }
    }

    palette.deselectAll();
};

b3.updatePaletteFromTable = data => {
    let infix = (settings.library.shape === 'cylinder') ? 'cylinder_' : '';
    data.forEach(element => {
        if (element.letterCode) {
            element.letterCode = element.letterCode.slice(0, 1);
        }
        element.finishName = infix + palette.finishList
        .find(_element => _element.display == element.finishName).lower;
        element.inner = palette.innerList
        .find(_element => _element.display == element.inner).lower;
    });
    b3.store.state.swatches.forEach((element, i) => {
        element.description = data[i].description;
        element.letterCode = data[i].letterCode;
        element.finishName = data[i].finishName;
        element.inner = data[i].inner;
        element.render();
    });
    historie.addAction();
    beads.refreshCanvas();
};

palette.clear = () => { // clears unused swatches
    let toDelete = [];
    b3.store.state.swatches.forEach(swatch => {
        if(!swatch.hasBeadsOnCanvas()) {
            toDelete.push(swatch.id);
        }
    });
    toDelete.forEach(id => {
        palette.deleteSwatch(b3.store.state.swatches.find(element => element.id == id));
    });
    menu.resetPaletteTable();
    historie.newProject(); // experimental
    historie.updateRecentState();
    palette.select(b3.store.state.swatches[0]);
};

palette.deleteSelectedSwatches = list => {
    list.forEach(obj => {
        palette.deleteSwatch(b3.store.state.swatches.find(element => element.id === obj.id));
    });
    menu.resetPaletteTable();
};

palette.closeSwatchDialog = () => {
    const inMenu = b3.store.state.currentScreen === 'menu';
    const myMode = inMenu ? 'browser' : 'draw';
    if (inMenu) save.currentlyOpenFile({forceSave: true});
    modes.start(myMode);
};

palette.clickSwatch = swatch => {
    if (!myInput.pointerEnabled) return;
    if (!modes.currentMode.onClickSwatch) return;
    modes.currentMode.onClickSwatch(swatch);
};

palette.selectBeads = swatch => {
    modes.start('select');
    let dummyBead = {
        style: swatch.id,
        active: true
    };
    beads.selectAll(dummyBead);
};

// should be in a select module
palette.inverse = () => {
    if (
        modes.currentMode.name === 'select'
        || (modes.currentMode.name === 'wand')
        || (modes.currentMode.name === 'marquee')
    ) {
        beads.arr.forEach(bead => {
            if (bead.ignore) return;
            if (bead.active) {
                if (bead.selected) {
                    beads.unselect(bead);
                } else {
                    beads.select(bead);
                }
            }
        });
    }
};

// should be in a select module
palette.selectAll = () => {
    if (
        modes.currentMode.name === 'select'
        || (modes.currentMode.name === 'wand')
        || (modes.currentMode.name === 'marquee')
    ) {
        beads.arr.forEach(bead => {
            if (bead.ignore) return;
            if (bead.active) beads.select(bead);
        });
    }
};

palette.assign = (a, b) => {
    a.fillColor = b.fillColor;
    a.secondColor = b.secondColor;
    a.letterCode = b.letterCode;
    a.finishName = b.finishName;
    a.inner = b.inner;
    a.description = b.description;
    a.id = b.id;
    a.selected = b.selected;
    a.render();
};

palette.initialize = () => {
    palette.initializeSettings();
    b3.store.state.swatches = [];
};

palette.setHex = hex => {
    const color = Phaser.Display.Color.HexStringToColor(hex);
    b3.ee.emit('beadLibraryQuery', {color: color._color, trigger: 'input'});
};

palette.select = swatch => {
    palette.deselectAll();
    if (swatch === undefined) return;
    swatch.selected = true;
    palette.activeStyleId = swatch.id;
    swatch.render();
};

palette.deselectAll = () => {
    b3.store.state.swatches.forEach(element => {
        element.selected = false;
    });
    palette.activeStyleId = null;
};

palette.assignSymbols = ({swatchList=b3.store.state.swatches, preserve}) => { // auto assign symbols to all blank styles

    const getPaletteCodes = () => {
        let codes = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz1234567890';

        for (let i = 200; i < 600; i++) {
            codes += String.fromCharCode(i);
        }

        return codes;
    };
    const myPaletteCodes = getPaletteCodes();

    let existingLetters = [];

    b3.store.state.swatches.forEach(swatch => {
        if (swatchList.some(s => s.id === swatch.id)) return; // don't add letters of swatches to be overwritten
        if (swatch.letterCode) existingLetters.push(swatch.letterCode);
    });

    let myIndex = 0;
    let getNextCode = () => {
        while (existingLetters.some(element => element === myPaletteCodes[myIndex])) {
            myIndex++;
        }
        let result = myPaletteCodes[myIndex];
        myIndex++;
        return result;
    };


    swatchList.forEach(swatch => {
        if (preserve) {
            if (!swatch.letterCode) {
                swatch.letterCode = getNextCode();
            }
        } else {
            swatch.letterCode = getNextCode();
        }
    });

    menu.resetPaletteTable();
    beads.refreshCanvas();
    historie.addAction();
};

palette.matchStyles = list => { // auto match all styles to library
    if (!b3.store.state.swatches.length) return;

    const mySwatches = list.map(e => b3.store.state.swatches.find(s => s.id === e.id));

    mySwatches.forEach(swatch => {
        const myColor = Phaser.Display.Color.IntegerToColor(swatch.fillColor);
        const myResult = beadLibrary.sortBeadsByColor(myColor.r, myColor.g, myColor.b)[0];
        const rgb = Phaser.Display.Color.GetColor(...myResult.c);

        const description = `${myResult.t} (${myResult.id})`;

        palette.assign(swatch, {
            fillColor: rgb,
            secondColor: myResult.secondColor || null,
            letterCode: swatch.letterCode,
            finishName: myResult.finishName || utils.finishes[myResult.b],
            inner: myResult.inner || 'opaque',
            description,
            id: swatch.id,
            selected: swatch.selected
        });
    });

    menu.resetPaletteTable();
    palette.select(b3.store.state.swatches[0]);
    beads.refreshCanvas();
    historie.addAction();
};

const getPaletteData = () => {
    defaultPalette.forEach(element => {
        element.name = lang.get('default palette color: ' + element.name.toLowerCase(), element.name);
    });

    return defaultPalette;
};

palette.addDefaultPalette = () => {
    const finishName = [
        { shape: 'round', finish: 'matte' },
        { shape: 'cylinder', finish: 'cylinder_matte' },
        { shape: 'plastic', finish: 'plastic' },
    ].find(e => e.shape === settings.library.shape).finish;

    getPaletteData().forEach(color => {
        palette.addSwatch({
            fillColor: color.hexcode,
            description: color.name,
            finishName,
            inner: 'opaque',
            secondColor: null,
            addHistory: false
        });
    });
};

palette.addFromMyCollection = collectionTitle => {
    const collection = b3.store.state.collections.find(e => e.title === collectionTitle);
    if (!collection?.beadIdList) return;

    beadLibrary.getStash({collection})
        .map(element => beadLibrary.convertLibraryBead(element))
        .map(item => ({
            ...item,
            description: `${item.details} (${item.title})`
        }))
        .forEach(swatch => palette.addSwatch(swatch));
};
